/*
 * Footer club button.
 *
 * Native port of the Variant experience "vip-club-button-footer". Markup:
 * snippets/footer-club-button.liquid, styles: assets/custom.css.
 *
 * The button is a plain link to the club page, so the only behaviour left here
 * is the one thing markup cannot express: when the Valuecard widget is on the
 * page, open its panel instead of navigating. The observer the original used
 * to wait for the footer to render is gone - the markup is rendered by the
 * theme.
 */
(function () {
  'use strict';

  var button = document.querySelector('[data-footer-club-button]');
  if (!button) return;

  button.addEventListener('click', function (event) {
    // The club panel belongs to the Valuecard widget, which renders its own tab
    // (hidden in custom.css). There is no public API for it, so opening it
    // means clicking that tab - exactly what the original did. Without the
    // widget the link is left alone and the club page loads.
    var widget = document.querySelector('.vc-widget-left');
    if (!widget) return;

    event.preventDefault();
    widget.click();
  });
})();
